import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { IDLE_TIMEOUT } from '../constants';

const promptBeforeIdle: number = 1_000;

export const useIdle = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onPrompt = () => {
    setIsOpen(true);
  };

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onPrompt,
    promptBeforeIdle
  });

  return {
    isOpen,
    setIsOpen
  };
};
